import React from "react";
import styled from "styled-components/macro";
import { InfoCircleOutlined } from "@ant-design/icons";

export const Root = styled.div`
  display: flex;
  padding: 8px;
  gap: 8px;
  background: #fbfbfb;
  color: ${(p) => p.theme.colors.midGrey};
  border-radius: 8px;
  align-items: flex-start;

  .anticon {
    margin-top: 4px;
  }
`;
const Text = styled.div`
  font-size: 12px;
`;

export const InfoBox: React.FC<{
  className?: string;
  children: React.ReactNode;
}> = ({ className, children }) => {
  return (
    <Root className={className}>
      <InfoCircleOutlined />
      <Text>{children}</Text>
    </Root>
  );
};
